const agreementdata = {
 agreement_title: "",
    agreement_description: "",
    customer_id: null,
    agreement_type: "",
    service_coverage: "",
    customer_coverage: "",
    agreement_status: "",
    version_number: null,
    term_type: "",
    term_start_date: "",
    term_end_date: "",
    payment_terms: "",
    signature_date: "",
    parent_agreement_id: null,
    parent_agreement_title: "",
    comments: "",
    agreement_modification_comment:""
};

export default agreementdata;
